<template>
  <div>
    <FiltroHistorico v-model="filtro" @filtrar="(obj) => changeFiltro(obj)" @reload="reloadFiltro" />
    <div class="pa-2">
      <table-cadu
        class="historico"
        v-model="selected"
        custom
        nameTab="historicoAba"
        :editar="true"
        :rows="rows"
        :showCheck="false"
        :rowsHeader="rowsHeader"
        :items="['05', '10', '15', '20']"
        :elementsPerPageProp="elementsPerPage"
        :pagina="pagina"
        :qtPaginas="qtPaginas"
        :qtResultados="qtResultados"
        :ordemProp="ordem"
        :loading="loading"
        :disabledButtons="[true, false, false, true, canDownload]"
        @filtro-click="filtro = true"
        @change-element="changeSelect"
        @change-page="(page) => changePage(page.currentPage)"
        @clickButton="clickHistorico"
        @ordena="(obj) => changeOrdem(obj)"
      />
    </div>
    <ExcluirModal
      :text="'Tem certeza que deseja excluir esse Mandato?'"
      :showDelete="showDelete"
      @close="showDelete = false"
      @confirmDelete="confirm()"
    />
    <SucessoModal :showSucess="showSucess" :sucessType="type" successName="Histórico" @close="showSucess = false" />
    <error-modal v-model="showError" :errObj="errObj" />
  </div>
</template>

<script>
import FiltroHistorico from './FiltroHistorico'
import VersaoHistorico from '@/services/Historico/VersaoHistorico'
import Usuario from '@/services/Usuario'
import jwtDecode from 'jwt-decode'

export default {
  components: {
    FiltroHistorico
  },
  data() {
    return {
      filtro: false,
      selected: [],
      rows: [],
      rowsHeader: [
        { text: 'Versão', icon: 'repeat' },
        { text: 'Data Alteração', icon: 'repeat' },
        { text: 'Colaborador', icon: 'repeat' },
        { text: 'Aba Atualizada', icon: 'repeat' },
        { text: 'Necessário Aprovação', icon: 'repeat' }
      ],
      elementsPerPage: '10',
      pagina: 1,
      qtPaginas: 1,
      qtResultados: 5,
      ordem: 'desc',
      showDelete: false,
      showSucess: false,
      showError: false,
      errObj: {
        status: '',
        error: ''
      },
      type: '',
      loading: false,
      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit')),
      dataInicial: '',
      dataFinal: '',
      ordenacao: 'numero',
      tokenBearer: localStorage.getItem('tokenBearer'),
      idUnimed: -1,
      tipoAnexoId: '',
      abaAtualizada: ''
    }
  },
  async beforeMount() {
    let decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role
    await this.loadingWithGetVersoes()
  },
  methods: {
    async loadingWithGetVersoes() {
      this.loading = true
      await this.getIdUnimedUsuario()
      await this.getVersoes()
      this.loading = false
    },
    async getIdUnimedUsuario() {
      let usuario = new Usuario(this.tokenBearer, this.$appConfig.config.API)

      try {
        let response = await usuario.getUser()
        response = response.data
        this.idUnimed = response.unimed.id
      } catch (err) {
        console.error(err)
        this.showError = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.message
      }
    },
    changeFiltro(obj) {
      this.filtro = false
      this.tipoAnexoId = obj.idAnexo
      this.abaAtualizada = obj.abaAtualizada
      this.dataInicial = obj.dataInicial
      this.dataFinal = obj.dataFinal
      this.pagina = 1
      this.loadingWithGetVersoes()
    },
    reloadFiltro() {
      this.tipoAnexoId = ''
      this.loadingWithGetVersoes()
    },
    changeSelect(element) {
      this.elementsPerPage = element
      this.pagina = 1
      this.loadingWithGetVersoes()
    },
    changePage(page) {
      this.pagina = page
      this.loadingWithGetVersoes()
    },
    clickHistorico(obj) {
      switch (obj.type) {
        case 'recibo':
          this.$emit('recibo', this.rows[obj.index].id)
          break
        case 'view':
          this.$emit('historico', this.rows[obj.index].id)
          break
        case 'anexo':
          this.$emit('anexo', this.rows[obj.index].id)
          break
      }
    },
    changeOrdem({ ordem, index }) {
      const ordenacoes = {
        0: 'numero',
        1: 'dataCriacao',
        2: 'usuarioCaduCriacao.nome',
        3: 'abasAlteradas',
        4: 'usuarioCaduAprovacao'
      }

      switch (index) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
          this.ordenacao = ordenacoes[index]
          this.ordem = ordem
          break

        default:
          this.ordenacao = 'numero'
          this.ordem = 'asc'
          break
      }

      this.ordem = ordem
      this.loadingWithGetVersoes()
    },
    async getVersoes() {
      let versaoHistorico = new VersaoHistorico(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        let response = await versaoHistorico.getVersoes(this.args)
        response = response.data
        this.rows = response.conteudo
        this.pagina = response.pagina
        this.qtPaginas = response.qtPaginas
        this.qtResultados = response.qtResultados
      } catch (err) {
        console.error(err)
        this.showError = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.message
      }
    }
  },
  computed: {
    canDownload() {
      return (
        this.role === 'admin_brasil' ||
        this.role === 'colaborador_brasil' ||
        this.role === 'colaborador_dirigente' ||
        ((this.role === 'admin_brasil' ||
          this.role === 'colaborador_brasil' ||
          this.role === 'colaborador_dirigente' ||
          this.role === 'admin' ||
          this.role === 'dirigente') &&
          this.idUnimed === this.$idUnimed)
      )
    },
    args() {
      return `&direcaoOrdenacao=${this.ordem}&ordenacao=${this.ordenacao}&pagina=${this.pagina}&tamanhoPagina=${this.elementsPerPage}&tipoAnexoId=${this.tipoAnexoId}&dataInicio=${this.dataInicial}&dataFim=${this.dataFinal}&abaAlterada=${this.abaAtualizada}`
    }
  }
}
</script>

<style lang="sass">
.circle-status
    border-radius: 10px
    width: 9px
    height: 9px

.historico > .table-cadu
    border: none
    border-radius: 0px
    width: 100% !important

.historico > .table-cadu > .table > table
    width: 100% !important
</style>
